
type ZLabelProps = {
    children?: React.ReactNode | string;
    className?: string;
    preventSelect?: boolean;
};

export const ZLabel = ({ children, className, preventSelect}: ZLabelProps) => {
    return (
        <div className={
            `zlabel${preventSelect ? " prevent-select" : ""}${className ? ` ${className}` : ""}`
        }>
            {children}
        </div>
    );
}